import * as React from "react"
import { Box } from "@mui/material"
import {useProductPageKpiReportForm} from "./@hooks";
import { ActionButton } from "@components"


export default function CreateReportButton() {
    const { handleOpenForm, isLoadingDrawer } = useProductPageKpiReportForm()

    return <Box componet="span" data-tour="pp-kpi-create-report">
        <ActionButton
            isLoading={isLoadingDrawer}
            label="Create New Report"
            icon="pen-to-square"
            onClick={handleOpenForm}
        />
    </Box>
}